module.exports = __webpack_public_path__ + "static/media/step_4.fcb026a9.png";